import apiClient from "./apiClient";

export const SUB_DIVISION_UPDATE_SUPPORTED = true;

export const getSubDivisions = async (params = {}) => {
  const response = await apiClient.get("/api/sub-divisions", { params });
  return (
    response.data?.sub_divisions || response.data?.data || response.data || []
  );
};

export const getSubDivisionById = async (subDivisionId) => {
  const response = await apiClient.get(`/api/sub-divisions/${subDivisionId}`);
  return (
    response.data?.sub_division || response.data?.data || response.data || null
  );
};

export const createSubDivision = async (payload) => {
  const response = await apiClient.post("/api/sub-divisions", payload);
  return response.data;
};

export const updateSubDivision = async (subDivisionId, payload) => {
  const response = await apiClient.put(
    `/api/sub-divisions/${subDivisionId}`,
    payload
  );
  return response.data;
};
